// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__QY3L8","title":"Heading_title__3C_kV","illustration":"Heading_illustration__26GEd"};